module.exports = __webpack_public_path__ + "static/media/bg41.95e2657a.png";